import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/pay/cash.png'
import _imports_1 from '@/assets/pay/manual.png'
import _imports_2 from '@/assets/pay/paylater.png'


const _withScopeId = n => (_pushScopeId("data-v-cadaaae4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-money-bill py-icon-color" }, null, -1))
const _hoisted_3 = { class: "row text-center" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "pay-size-bx" }
const _hoisted_6 = { class: "py-span" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Cash ")
const _hoisted_9 = { class: "pay-size-bx" }
const _hoisted_10 = { class: "py-span" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Card ")
const _hoisted_13 = {
  key: 0,
  class: "pay-size-bx"
}
const _hoisted_14 = { class: "py-span" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Pay Later ")
const _hoisted_17 = { class: "row py-description" }
const _hoisted_18 = {
  style: {"height":"0.2em","background-color":"#fff"},
  class: "col-md-12"
}
const _hoisted_19 = { class: "col-md-2 col-sm-12 content-height p-pl-1 p-pr-0" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "mt-2" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "mt-2" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "mt-2" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "col-md-3 col-sm-12" }
const _hoisted_28 = { class: "content-height" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-file-o py-icon-color",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Key Pad ")
], -1))
const _hoisted_30 = {
  class: "btn-group-vertical text-center",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_31 = { class: "btn-group btn-group-lg" }
const _hoisted_32 = { class: "btn-group btn-group-lg" }
const _hoisted_33 = { class: "btn-group btn-group-lg" }
const _hoisted_34 = { class: "btn-group btn-group-lg" }
const _hoisted_35 = {
  class: "btn-group btn-group-lg",
  style: {"margin-top":"1px"}
}
const _hoisted_36 = { class: "col-md-4 col-sm-12" }
const _hoisted_37 = {
  key: 0,
  class: "content-height"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-id-card py-icon-color",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Add Card Payments Manually ")
], -1))
const _hoisted_39 = { class: "transactions-card-manual" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Card Type", -1))
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Account No (Last 4 digits)", -1))
const _hoisted_44 = {
  key: 1,
  class: "content-height"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "transactions" }, [
  /*#__PURE__*/_createElementVNode("h5", null, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "pi pi-money-bill py-icon-color",
      "aria-hidden": "true"
    }),
    /*#__PURE__*/_createTextVNode(" Add Tendered Cash ")
  ])
], -1))
const _hoisted_46 = { class: "col-md-12 p-0" }
const _hoisted_47 = { class: "col-md-3 col-sm-12" }
const _hoisted_48 = { class: "content-height" }
const _hoisted_49 = { class: "transactions" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-money-bill py-icon-color",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Payment Methods ")
], -1))
const _hoisted_51 = {
  id: "customer_payment_method_manual",
  class: "table table-bordered table-striped py-list-collections table-hover"
}
const _hoisted_52 = { class: "text-left" }
const _hoisted_53 = { class: "text-left" }
const _hoisted_54 = { id: "history_total_cash" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"background-color":"green","color":"#fff"} }, " Total ", -1))
const _hoisted_59 = {
  class: "text-left",
  style: {"background-color":"green","color":"#fff"}
}
const _hoisted_60 = { class: "confirmation-content" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_62 = /*#__PURE__*/_createTextVNode("Are you sure to cancel ? You will lost the payments of amount ")
const _hoisted_63 = { class: "confirmation-content" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_65 = /*#__PURE__*/_createTextVNode("Are you sure to continue this invoice. The remaining balance for this invoice is ")
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" ? ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.paymentDialog,
      "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.paymentDialog) = $event)),
      style: { width: '100vw' },
      modal: true,
      closable: true,
      position: "top",
      onHide: _ctx.confirmPaymentCancel,
      class: "p-fluid p-m-0 p-dialog-maximized",
      showHeader: true
    }, {
      header: _withCtx(() => [
        _createElementVNode("h6", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.dialogTilte), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _createVNode(_component_RadioButton, {
                  modelValue: _ctx.paymentMethodType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paymentMethodType) = $event)),
                  value: "Cash"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("p", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, [
                _hoisted_11,
                _hoisted_12,
                _createVNode(_component_RadioButton, {
                  modelValue: _ctx.paymentMethodType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paymentMethodType) = $event)),
                  value: "Manual"
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_ctx.restriction != 'Yes')
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createVNode(_component_RadioButton, {
                      modelValue: _ctx.paymentMethodType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paymentMethodType) = $event)),
                      value: "Pay Later"
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_ctx.progressBar)
              ? (_openBlock(), _createBlock(_component_ProgressBar, {
                  key: 0,
                  mode: "indeterminate",
                  style: {"height":"0.2em"}
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h5", null, [
              _createTextVNode(" (" + _toDisplayString(_ctx.currency) + ") Amount Due ", 1),
              _createElementVNode("input", {
                type: "text",
                value: _ctx.fixLength(_ctx.paymentRounding),
                readonly: "",
                class: "form-control py-customize-bx mt-1 py-balance-due"
              }, null, 8, _hoisted_20)
            ]),
            _createElementVNode("h5", _hoisted_21, [
              _createTextVNode(" (" + _toDisplayString(_ctx.currency) + ") Tendered ", 1),
              _createElementVNode("input", {
                style: {"color":"green"},
                type: "number",
                readonly: "",
                value: _ctx.fixLength(_ctx.paymentAction.tendered),
                class: "form-control py-customize-bx mt-1"
              }, null, 8, _hoisted_22)
            ]),
            _createElementVNode("h5", _hoisted_23, [
              _createTextVNode(" (" + _toDisplayString(_ctx.currency) + ") Change ", 1),
              _createElementVNode("input", {
                type: "number",
                readonly: "",
                value: _ctx.fixLength(_ctx.changeAmount),
                class: "form-control py-customize-bx mt-1"
              }, null, 8, _hoisted_24)
            ]),
            _createElementVNode("h5", _hoisted_25, [
              _createTextVNode(" (" + _toDisplayString(_ctx.currency) + ") Round Off ", 1),
              _createElementVNode("input", {
                type: "number",
                readonly: "",
                value: _ctx.fixLength(_ctx.roundedAmt),
                class: "form-control py-customize-bx mt-1"
              }, null, 8, _hoisted_26)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.amountNumpad(1))),
                    class: "btn-numpad col-sm-4"
                  }, " 1 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.amountNumpad(2))),
                    class: "btn-numpad col-sm-4"
                  }, " 2 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.amountNumpad(3))),
                    class: "btn-numpad col-sm-4"
                  }, " 3 ")
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.amountNumpad(4))),
                    class: "btn-numpad"
                  }, " 4 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.amountNumpad(5))),
                    class: "btn-numpad"
                  }, " 5 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.amountNumpad(6))),
                    class: "btn-numpad"
                  }, " 6 ")
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.amountNumpad(7))),
                    class: "btn-numpad"
                  }, " 7 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.amountNumpad(8))),
                    class: "btn-numpad"
                  }, " 8 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.amountNumpad(9))),
                    class: "btn-numpad"
                  }, " 9 ")
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.amountNumpad('.'))),
                    class: "btn-numpad"
                  }, " . "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.amountNumpad(0))),
                    class: "btn-numpad"
                  }, " 0 "),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.amountNumpad('del'))),
                    class: "btn-numpad-danger"
                  }, " Del ")
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_Button, {
                    label: "Exact",
                    icon: "pi pi-ticket",
                    class: "p-button-lg p-button-primary p-4",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.exactAmount())),
                    disabled: _ctx.paymentMethodType == ''
                  }, null, 8, ["disabled"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            (_ctx.paymentMethodType == 'Manual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createVNode(_component_Dropdown, {
                        options: _ctx.methodList,
                        modelValue: _ctx.cardType,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.cardType) = $event)),
                        optionLabel: "cardName"
                      }, null, 8, ["options", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createVNode(_component_InputText, {
                        placeholder: "e.g 3217",
                        modelValue: _ctx.accountNo,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.accountNo) = $event)),
                        modelModifiers: { trim: true }
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode(_component_Button, {
                    label: "Add Card Payment",
                    icon: "pi pi-money-bill",
                    onClick: _ctx.addManualAmount,
                    class: "p-button-lg p-button-warning p-4"
                  }, null, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.paymentMethodType == 'Cash')
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_Button, {
                      label: "Add Cash",
                      icon: "pi pi-money-bill",
                      class: "p-button-lg p-button-warning p-4",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.addCashAmount())),
                      disabled: _ctx.paymentMethodType == ''
                    }, null, 8, ["disabled"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("table", _hoisted_51, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentList, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: item }, [
                      _createElementVNode("td", _hoisted_52, _toDisplayString(item.paymentType), 1),
                      _createElementVNode("td", _hoisted_53, [
                        _createTextVNode(_toDisplayString(_ctx.currency) + " ", 1),
                        _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.fixLength(item.transTotalAmount)), 1),
                        _createElementVNode("span", {
                          onClick: ($event: any) => (_ctx.deletePayment(index, item)),
                          class: "payment_cross"
                        }, _hoisted_57, 8, _hoisted_55)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("tr", null, [
                    _hoisted_58,
                    _createElementVNode("td", _hoisted_59, [
                      _createTextVNode(_toDisplayString(_ctx.currency) + " ", 1),
                      _createElementVNode("b", null, _toDisplayString(_ctx.fixLength(_ctx.totalPaymentsReceived)), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_Button, {
                label: "Done",
                icon: "pi pi-check-circle",
                class: "p-button-lg p-button-primary p-4",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.confirmPayments())),
                disabled: 
              (_ctx.restriction == 'Yes' && _ctx.paymentRounding  > 0) ||
             (_ctx.paymentMethodType != 'Pay Later' && _ctx.totalPaymentsReceived <= 0) ||
             (_ctx.paymentMethodType == 'Pay Later' && _ctx.totalPaymentsReceived > 0)
            
              }, null, 8, ["disabled"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onHide"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.paymentCancelDialog,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.paymentCancelDialog) = $event)),
      style: { width: '600px' },
      header: "Confirm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _ctx.cancelPaymentConfirm
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          class: "p-button-danger",
          onClick: _ctx.closePaymentScreen
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_60, [
          _hoisted_61,
          _createElementVNode("span", null, [
            _hoisted_62,
            _createElementVNode("b", null, " $" + _toDisplayString(_ctx.fixLength(_ctx.totalPaymentsReceived)), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.paymentConfirmDialog,
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.paymentConfirmDialog) = $event)),
      style: { width: '600px' },
      header: "Confirm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.paymentConfirmDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          class: "p-button-danger",
          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.emitPayments()))
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_63, [
          _hoisted_64,
          _createElementVNode("span", null, [
            _hoisted_65,
            _createElementVNode("b", null, " $" + _toDisplayString(_ctx.fixLength(_ctx.paymentRounding)), 1),
            _hoisted_66
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}